import { useRouter } from 'vue-router'
import { isNativeShellApp } from '@/utils/appBridgeGate'

export const useBack = () => {
  const router = useRouter()

  /**
   * 상황에 따라 router.back() 또는 window.history.back()을 실행하는 유틸 함수
   * - Vue Router 히스토리가 존재할 경우 router.back() 사용
   * - 브라우저 히스토리가 있으면 window.history.back() 사용
   * - 둘 다 없으면 fallback 경로 (기본값: '/')로 이동
   */
  const goBack = (fallbackUrl = '/') => {
    const hasRouterHistory = !!router.options.history.state.back
    const hasBrowserHistory = window.history.length > 1
    if (hasRouterHistory) {
      router.back()
    } else if (hasBrowserHistory) {
      window.history.back()
    } else {
      window.location.href = fallbackUrl
    }
  }

  const routeBack = (backUrl?: string, _redirectRoot?: boolean, partnersKey?: string) => {
    const rootUrl = partnersKey ? `/partners/${partnersKey}/` : '/'

    if (backUrl) {
      window.location.href = partnersKey ? `/partners/${partnersKey}${backUrl}` : backUrl
      return
    }

    const hasHistory = !!window.history.state?.back

    if (!hasHistory) {
      if (isNativeShellApp()) {
        // 2.2.7 이상: 웹 홈 대신 네이티브 홈으로 복귀
        window.flutter_inappwebview?.callHandler('openNativeScreen', {
          screen: 'home'
        })
        return
      }

      // 2.2.6 이하 / 일반 브라우저: 웹 홈 이동
      window.location.href = rootUrl
      return
    }

    window.history.back()
  }

  return { goBack, routeBack }
}
